import {ErrorState} from '@wandb/components';
import React from 'react';
import {Redirect, useHistory, useLocation} from 'react-router-dom';

import {AccessDenied} from '../components/AccessDenied';
import {LOGIN_PATH} from '../routes/auth/authPaths';
import {useViewer} from '../state/viewer/hooks';
import {setAuthRedirect} from '../util/auth';
import {isInIframe} from '../util/window';
import {TailwindContents} from '../weave/components/Tailwind';

interface NoMatchProps {
  unrecoverable?: boolean;
}

// We are deprecating NoMatch in favor of the pages/NoAccessPage
const NoMatch: React.FC<NoMatchProps> = ({unrecoverable}) => {
  const viewer = useViewer();
  const history = useHistory();
  const location = useLocation();
  const loggedIn = viewer != null;

  const helpMessage = loggedIn
    ? 'If this is the right URL, you might need to ask the page owner to change the privacy permissions or invite you to the team.'
    : 'If this is the right URL, you might need to log in or ask the page owner to change the privacy permissions.';

  const buttonText = loggedIn ? 'Go to home page' : 'Log in to W&B';

  const authRedirect = new URLSearchParams(location.search).get('authRedirect');
  const redirectTo = `${location.pathname}${location.search}${location.hash}`;
  const loginLocation = {
    pathname: LOGIN_PATH,
    state: {prompt: true, from: location, internal: true},
  };

  const handlePrimaryAction = () => {
    if (loggedIn) {
      history.push('/');
      return;
    }
    setAuthRedirect(redirectTo);
    history.push(loginLocation);
  };

  if (!loggedIn && authRedirect) {
    setAuthRedirect(redirectTo);
    return <Redirect to={loginLocation} />;
  }

  return isInIframe() ? (
    <AccessDenied unrecoverable={unrecoverable} />
  ) : (
    <TailwindContents>
      <div className="flex w-full flex-1 justify-center px-16 py-64">
        <ErrorState
          variant="404"
          body={helpMessage}
          primaryActionLabel={buttonText}
          onPrimaryAction={handlePrimaryAction}
        />
      </div>
    </TailwindContents>
  );
};

export default NoMatch;
